module.exports = __webpack_public_path__ + "img/wpfx.6914b192.svg";